export type AppLoadingContent = {
  title: string | undefined;
  message: string | undefined;
  /** Shown below the loading animation */
  caption?: string;
  delay?: boolean;
  type?: 'home' | 'auto';
};

export type AppLoadingDefaultContentTypes = 'default' | 'prefil' | 'resume' | 'auto' | 'directQuote';

export const APP_LOADING_CONTENT: Record<AppLoadingDefaultContentTypes, AppLoadingContent> = {
  default: {
    title: undefined,
    message: undefined,
  },
  prefil: {
    title: 'Getting Your Quote Ready',
    message: "We're pre-filling your details. You'll just need to provide a bit more information to get your personalized quote.",
    delay: true,
  },
  resume: {
    title: 'Resuming Your Application',
    message: "We're loading your application. You may need to provide a few more details to finalize your quote or purchase your policy.",
    delay: true,
  },
  auto: {
    title: undefined,
    message: undefined,
    type: 'auto',
  },
  directQuote: {
    title: 'Loading your information...',
    message: undefined,
    caption: "(we'll get started in a sec)",
  },
};
